module.exports = __webpack_public_path__ + "media/images/emblems/Vetroz-30be7dfc2334767f863bd99264849b3f.png";